import { createSelector } from '@reduxjs/toolkit';
import { RootState, store } from '@store/store';
import { getDateWithoutTime } from 'components/global/utils';



export const selectUser = (state: RootState) => state.global.user;
export const selectAppMode = (state: RootState) => state.global.appMode;
export const selectLanguage = (state: RootState) => state.global.language;
export const selectSelectedDate = (state: RootState) => state.global.selectedDate;
export const selectGlobalSearch = (state: RootState) => state.global.globalSearch;
export const selectSearchTypes = (state: RootState) => state.global.searchTypes;
export const selectSearchDateRange = (state: RootState) => state.global.searchDateRange;



export const selectUserId = createSelector(selectUser, user => user ? user.userId : "");
export const selectUserRoles = createSelector(selectUser, user => user && user.roles ? user.roles : []);
export const selectedDateWithoutTime = createSelector(selectSelectedDate, date => getDateWithoutTime(date));



export const plainSelectUser = () => {
	const storeObject = store.getState();
	return storeObject && storeObject.global ? storeObject.global.user : null;
};